module.exports = __webpack_public_path__ + "static/media/minus-round.0cf99341.svg";